import {
  FETCH_CLAIM_REPORTS_REQUEST,
  FETCH_CLAIM_REPORTS_SUCCESS,
  FETCH_CLAIM_REPORTS_FAILURE,
} from './actionTypes';

const initialState = {
  claimReports: [],
  loading: false,
  error: null,
  success: false,
};

const ReimbursementReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLAIM_REPORTS_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case FETCH_CLAIM_REPORTS_SUCCESS:
      return { ...state, loading: false, claimReports: action.payload, success: true };
    case FETCH_CLAIM_REPORTS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    default:
      return state;
  }
};

export default ReimbursementReportsReducer;
